import { createServerFn } from "@tanstack/react-start";
import { readPlatformShell } from "../platform/shell.server";
import { readSiteShell } from "./shell.server";
import { siteContext } from "./site.server";
import { templatePreviewExists } from "./template-preview.server";

export type SiteShell = Awaited<ReturnType<typeof readSiteShell>>;

/**
 * The shell for the document a visitor opened at this path (root route loader): a creator's site,
 * or Drate's own pages on the platform host.
 */
export const loadSiteShell = createServerFn({ method: "GET" })
  .validator((path: unknown) =>
    typeof path === "string" && path.startsWith("/") && path.length <= 250 ? path : "/",
  )
  .handler(async ({ data: path, context }) => {
    const drate = await siteContext(context);
    // A template's example page is its own document, without Drate's header or a site's.
    if (!drate.creator && (await templatePreviewExists(drate, path)))
      return { templatePreview: true as const };
    const shell = drate.creator ? readSiteShell(drate, path) : readPlatformShell(drate);
    // A child route can finish with a redirect while this parallel root loader still reads.
    // Keep its request-scoped clients alive until those reads settle, including on redirects.
    context.executionCtx.waitUntil(shell);
    return shell;
  });
